import styles from './NewDropdown.module.scss';

interface IDropdownProps {
  children: React.ReactNode;
  isOpen: boolean;
  title: string;
  setIsOpen: (value: boolean) => void;
}

export const NewDropdown = ({
  children,
  isOpen,
  title,
  setIsOpen,
}: IDropdownProps) => {
  return (
    <div className={styles.container}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={styles.caption}
      >
        {title}
      </button>
      {isOpen && <div className={styles.content}>{children}</div>}
    </div>
  );
};
